var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBase = function SvgBase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M92.5.6c-28 3.7-46.8 12.6-64.1 30.5C10.2 50 .7 73.6.7 100s9.5 50 27.7 68.9c19.5 20.1 43.5 30.3 71.6 30.3s52.1-10.2 71.6-30.3c18.2-18.9 27.7-42.5 27.7-68.9 0-12.1-1.1-19.2-4.5-30C183.7 35.5 155.3 9.9 120 2.5 113 1 97.3 0 92.5.6M121 32.8c23.1 8.2 38.6 23.9 46.2 46.7 2 6 2.3 9 2.3 20.5s-.3 14.5-2.3 20.5c-16.8 50.3-77.5 66.4-115.4 30.7-11.4-10.8-19.7-26-21.3-39.5l-.7-5.7H134V94H29.7l.7-5.6c.8-7.3 5.6-19.4 10.6-27 8.3-12.7 22.9-23.8 37-28.3 9.3-2.9 10.2-3 24.5-2.6 9.8.2 14.4.8 18.5 2.3"
  })));
};
export default SvgBase;